export default __webpack_public_path__ + "static/IPhone_App_NEW_(20)-688e56b0588b09f1c9b392cd0a45e006.webp";